import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMemo } from 'react';
import { FaCheck } from 'react-icons/fa';
import { twMerge } from 'tailwind-merge';
import { strip } from '../../../utilities/strings';
import { useComboboxContext } from './Combobox';
import { isSelected } from './Combobox.helpers';
function buildTestSelector(item, testSelector) {
    return "".concat(testSelector, "-").concat(strip(item.label));
}
function ComboboxListItem(_a) {
    var dataItem = _a.dataItem, onChange = _a.onChange, onHover = _a.onHover, className = _a.className, style = _a.style, overrideSelected = _a.overrideSelected, isActive = _a.isActive, hideSelectedIcon = _a.hideSelectedIcon;
    var _b = useComboboxContext(), value = _b.value, useMultipleSelect = _b.useMultipleSelect, testSelector = _b.testSelector, handleSelect = _b.handleSelect;
    var selected = useMemo(function () { return (overrideSelected === undefined ? isSelected(value, dataItem) : overrideSelected); }, [value, dataItem, overrideSelected]);
    return (_jsxs("li", { className: twMerge('select-none flex items-center px-3 py-1.5 m-0', 
        // eslint-disable-next-line no-nested-ternary
        isActive && !dataItem.disabled
            ? 'bg-sky-500 text-white'
            : dataItem.disabled
                ? 'bg-zinc-100 text-zinc-400'
                : 'text-zinc-900', !useMultipleSelect && selected && 'font-bold', !dataItem.disabled && 'cursor-pointer', className), onClick: function () {
            if (!dataItem.disabled) {
                onChange(dataItem, selected);
                if (handleSelect) {
                    handleSelect(dataItem);
                }
            }
        }, onMouseMove: onHover, style: style, "data-cy": buildTestSelector(dataItem, testSelector), title: dataItem.label, children: [!hideSelectedIcon && (_jsx("span", { className: clsx('w-3 h-3 min-w-[0.75rem]', useMultipleSelect
                    ? 'inline-flex items-center justify-between mr-1.5 border rounded-sm'
                    : 'order-2 ml-auto', selected && useMultipleSelect ? 'bg-sky-500 border-sky-500 text-white' : '', 
                // eslint-disable-next-line no-nested-ternary
                useMultipleSelect ? (isActive ? 'border-white' : 'border-slate-800') : ''), children: selected && _jsx(FaCheck, { className: "text-sm" }) })), _jsxs("span", { className: "truncate", children: [dataItem.label, dataItem.subLabel && (_jsxs(_Fragment, { children: ["\u00A0", _jsx("span", { className: twMerge('text-zinc-400', isActive && 'bg-sky-500 text-white'), children: dataItem.subLabel })] }))] })] }));
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
function ComboboxListGroup(_a) {
    var groupName = _a.groupName, data = _a.data;
    var _b = useComboboxContext(), onChange = _b.onChange, testSelector = _b.testSelector;
    // TODO: make grouping compatible with arrow key navigation
    return (_jsxs(_Fragment, { children: [_jsx("span", { className: "block px-3 pt-1.5 pb-0.5 m-0 font-semibold", "data-cy": "".concat(testSelector, "-group-name"), children: groupName }), data.map(function (dataItem) { return (_jsx(ComboboxListItem, { dataItem: dataItem, onChange: onChange, onHover: function () { }, className: "py-1 pl-5 hover:bg-sky-500 hover:text-white" }, dataItem.value)); })] }));
}
export { ComboboxListItem as default, ComboboxListGroup };
